import utilsProvider from '../../../components/providers/utils.provider';
import repository from '../../repositories/request/request.advance.repository';

const findAvailableByMainId = async (mainId, isPreview = false, calculatedDueDate = null) =>
    repository.findAvailableByMainId(mainId, isPreview, calculatedDueDate)
        .then(res => res.data);

const advance = async (mainId, advanceId, skipValidation) =>
    repository.advance(mainId, advanceId, skipValidation)
        .then(res => res.data);

const cancelAdvance = async (mainId, skipValidation = false) =>
    repository.cancelAdvance(mainId, skipValidation)
        .then(res => res.data);

const NO_BALANCE_REASON = 'Você não possui saldo para essa opção';

const isRefusedByValidation = (option) => !option.canAdvance && !option.canSkipValidation;

const isAdvanceOptionUnavailable = (option) => !option.billing || isRefusedByValidation(option);

const getAdvanceUnavailableReason = (option) => {

    if (!isAdvanceOptionUnavailable(option))
        return null;

    if (isRefusedByValidation(option))
        return option.unavailableReason || option.validationErrorMessage || null;

    return NO_BALANCE_REASON;
}

const getAdvanceLabel = (option) => {

    const advanceName = option.label || `Entrega em ${parseInt(option.hoursToDueDate / 24)} dia(s) ${option.isWorkHours ? 'úteis' : ''}`;
    const advancePrice = option.billing ? getAdvanceOptionPriceByBilling(option) : NO_BALANCE_REASON;
    const validationReason = isRefusedByValidation(option) ? getAdvanceUnavailableReason(option) : null;

    return (
        <div className='flex flex-col'>
            {`${advanceName} - ${advancePrice} `}
            {validationReason && (
                <span className='text-[10px]'>{validationReason}</span>
            )}
        </div>
    )
}

const getAdvanceOptionPriceByBilling = (option) =>
    option.billing.amount == 0 ? `Grátis` : `Preço: ${utilsProvider.formatNumberCurrency(option.billing.amount)}`;

export default {
    findAvailableByMainId,
    advance,
    cancelAdvance,
    getAdvanceLabel,
    isAdvanceOptionUnavailable,
    getAdvanceUnavailableReason
}